import React from "react";
import {Grid, Mui} from "@leap4/frontend";
import {IOwnership} from "@leap4/general-common";

const {Box, Slider, Typography, Input: MuiInput, styled} = Mui;

const Input = styled(MuiInput)`
  width: 42px;
`;

export interface setValueProps {
    setOwnership: (IOwnership) => void,
    ownership: IOwnership
}

export const InputSlider = (props: setValueProps)=> {

    const {ownership, setOwnership} = props

    const handleSliderChange = (event: Event, newValue: number | number[]) => {
        setOwnership(prevState => ({
            ...prevState,
            percent: Number(newValue),
            ownershipValue: 0
        }));
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setOwnership(prevState => ({
            percent: Number(event.target.value),
            ownershipValue: 0,
            ...prevState,
        }));
    };

    const handleBlur = () => {
        if (ownership.percent < 0) {
            setOwnership(
            prevState => ({
                percent: 0,
                ownershipValue: 0,
                ...prevState,
            }));
        } else if (ownership.percent > 100) {
            setOwnership(
                prevState => ({
                    percent: 100,
                    ownershipValue: 0,
                    ...prevState,
                }));
        }
    };

    return (
        <Box sx={{ width: 300 }}>
            <Typography id="input-slider" gutterBottom>
                {/*PERCENT*/}
            </Typography>
            <Grid container spacing={1} alignItems="center">
                    <Slider
                        value={typeof ownership.percent === 'number' ? ownership.percent : 0}
                        onChange={handleSliderChange}
                        aria-labelledby="input-slider"
                    />
                    <Input
                        value={typeof ownership.percent === 'number' ? ownership.percent : 0}
                        size="small"
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                        inputProps={{
                            step: 10,
                            min: 0,
                            max: 100,
                            type: 'number',
                            'aria-labelledby': 'input-slider',
                        }}
                    />
                    %
            </Grid>
        </Box>
    );
}